export function convertToDateString(input: string | number) {
  let date: Date

  if (typeof input === 'string') {
    const [year, month, day] = input.split('-')
    date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
  } else {
    date = new Date(input)
  }

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
